import { Select } from "shared/components";
import { roleOptions } from "../../settings-users/constants";
import { FC } from "react";
import { ROLE } from "providers/Auth";

type Props = {
  role: ROLE;
  onChange: (e: any) => void;
  isOwner?: boolean;
};

export const RoleSelect: FC<Props> = ({ isOwner, role, onChange }) => {
  return (
    <Select
      id="role"
      options={
        isOwner
          ? [
              {
                value: "owner",
                label: "Owner"
              },
              ...roleOptions
            ]
          : roleOptions
      }
      value={role}
      className="w-[297px]"
      label="Role"
      onChange={onChange}
      searchable={false}
      hideOptional
      isDisabled={isOwner}
    />
  );
};
